import moment from 'moment'
export default {
  props: ['course', 'imglist1', 'imglist2'],
  name: 'pdf-page',
  data () {
    return {
      formatDTeahcer1: '',
      formatDTeahcer2: '',
      suggestList: '',
      suggestBasics: '',
      introduce1: '',
      introduce2: '',
      courseOutlineDetail: '',
      output: '',
      dom: '',
      totals: [],
      pageNo: 1,
      viewHeight: 0,
      pdfUrl: 'https://cdn.gecacademy.cn/oa/upload/2022-07-27%2014-40-09-SL-Alex-Introduction%20to%20Machine%20Learning%20and%20Neural%20Networks-220628.pdf',
      vallist: [
        {
          val1: '项目共计108课时，包含在线直播45课时科研课程以及63课时录播（直播）先修课',
          list: [
            { val: '主导师授课', val1: '18课时' },
            { val: '副导师授课', val1: '18课时' },
            { val: '论文辅导', val1: '不限课时' }
          ]
        },
        {
          val1: '项目共计126课时，包含6周科研课程45课时，全球就业力大师课程18课时及63课时先修课程',
          list: [
            { val: '主导师授课', val1: '18课时' },
            { val: '副导师授课', val1: '18课时' },
            { val: '全球就业力大师课', val1: '18课时' },
            { val: '论文辅导', val1: '不限课时' }
          ]
        },
        {
          val1: '项目共计140+课时，采用线上与线下融合授课的形式。项目前两周为线上课程，后两周学生将来到营地，与教授、Teaching fellow、论文导师、助教及班主任开启两周的线下学习生活。',
          list: [
            { val: '教授授课', val1: '40课时' },
            { val: 'Teaching fellow授课', val1: '14课时' },
            { val: '论文导师授课', val1: '15课时' },
            { val: '先导课程', val1: '56课时' }
          ]
        }
      ],
      valObj: {}
    }
  },
  watch: {
    course: {
      handler: function (val) {
        this.course.schoolBegins = moment(this.course.schoolBegins).format('YYYY-MM-DD')
        this.formatBrMargin(this.course.teacherDetail)
        this.formatintroduce(this.course.introduce)
        this.courseOutlineDetail = this.formatEnter(this.course.courseOutlineDetail)
        this.getsuggestList()
        this.output = this.formatBrMargin1(this.course.output)
        if (this.course.typeId * 1 === 1) {
          this.valObj = this.vallist[0]
        }
        if (this.course.typeId * 1 === 6 || this.course.typeId * 1 === 32) {
          this.valObj = this.vallist[1]
        }
        if (this.course.typeId * 1 === 5) {
          this.valObj = this.vallist[2]
        }
      },
      deep: true
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 适合人群
    getsuggestList () {
      const suggestList = ['suggestSenior', 'suggestCollege', 'suggestMaster', 'suggestMiddle']
      const suggestText = []
      // 只选大学生【显示大学生及以上】其他正常显示
      if (!this.course.suggestSenior && !this.course.suggestMaster && !this.course.suggestMiddle && this.course.suggestCollege) {
        suggestText.push('大学生及以上')
      } else {
        for (const _key of suggestList) {
          if (this.course[_key]) {
            suggestText.push(_key === 'suggestSenior' ? '高中生' : _key === 'suggestCollege' ? '大学生' : _key === 'suggestMaster' ? '研究生' : _key === 'suggestMiddle' ? '初中生' : null)
          }
        }
      }
      //   for (const _key of suggestList) { if (data[_key]) { suggestText.push(_key === 'suggestSenior' ? '高中生' : _key === 'suggestCollege' ? '大学生' : null) } }
      if (suggestText.length > 0) {
        this.suggestList = '适合年级 (Grade): ' + suggestText.join('/')
      }
      if (this.course.suggestBasics) { this.suggestBasics = '适合专业 (Major): ' + this.course.suggestBasics }
    },
    // 项目介绍
    formatintroduce (data) {
      let result = ''
      let result1 = ''
      if (data) {
        data = data.split('\n')
        data.forEach((item, index) => {
          if (index < Math.round((data.length) / 2)) {
            result += `<p class="format-style-margin-item">${item}</p>`
          } else {
            result1 += `<p class="format-style-margin-item">${item}</p>`
          }
        })
      }
      this.introduce1 = result
      this.introduce2 = result1
    },
    formatEnter (data) {
      let result = ''
      if (data) {
        data = data.split('\n')
        for (const item of data) {
          result += `<p class="format-style-list-item">${item}</p>`
        }
      }
      return result
    },
    formatBrMargin (data, type) {
      let result = ''
      // let result1 = ''
      if (data) {
        data = data.split('\n')
        data.forEach((item, index) => {
          if (this.getStrlen(item) > 20) {
            result += `<p class="format-style-margin-item">${item}</p>`
          }
        })
      }
      this.formatDTeahcer1 = result
      // this.formatDTeahcer2 = result1
    },
    formatBrMargin1 (data, type) {
      let result = ''
      // let result1 = ''
      if (data) {
        data = data.split('\n')
        data.forEach((item, index) => {
          result += `<p class="format-style-margin-item">${item}</p>`
        })
      }
      return result
      // this.formatDTeahcer2 = result1
    },
    getStrlen (str) {
      var json = { len: 0 }
      var re = /[\u4e00-\u9fa5]/
      for (var i = 0; i < str.length; i++) {
        if (re.test(str.charAt(i))) {
          json.len++
        }
      };
      return json.len
    },
    createCanvas (totalPages) {
      for (let i = 1; i <= totalPages; i++) {
        this.totals.push(i)
      }
    },
    // 分页
    scrollfun (e) {
      const scrollTop = e.target.scrollTop
      if (scrollTop === 0) {
        this.pageNo = 1
      } else {
        this.pageNo = Math.ceil(scrollTop / this.viewHeight)
      }
    },
    // 放大
    scalBig () {
      this.scale = this.scale + 0.1
    },
    // 缩小
    scalSmall () {
      if (this.scale > 1.2) {
        this.scale = this.scale - 0.1
      }
    }
  }
}
